import global from 'global';

const prettierStatus = (status?: global.stop_factor | 'N/A'): string | null | undefined => {
	switch (status) {
		case 'approved':
			return 'Approved';
		case 'rejected':
			return 'Rejected';
		case 'review':
			return 'Review';
		case 'N/A':
			return 'N/A';
		default:
			return 'No decision';
	}
};

export const stopFactorStatusTranscript = (
	status?: global.stop_factor | string,
): string | undefined | null => {
	switch (status) {
		case 'approved':
			return 'Pass';
		case 'rejected':
			return 'Fail';
		case 'review':
			return 'Review';
		case 'N/A':
			return 'N/A';
		default:
			return 'No decision';
	}
};

export default prettierStatus;
